import { render, staticRenderFns } from "./icon-calendar.vue?vue&type=template&id=0be8296a&"
import script from "./icon-calendar.vue?vue&type=script&lang=js&"
export * from "./icon-calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports